module.exports = __webpack_public_path__ + "media/images/login_bg_01-6168692bb9516d86db9d28f3d8c3f0f5.jpg";